import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'

import { getNumber, getDisconnectionFee, disconnectService } from 'features/Numbers/Numbers.actions'
import NumbersDisconnectModal from './NumbersDisconnectModal'

const formName = 'disconnectServiceForm'

const stateToProps = ({ numbers, form }, { serviceId }) => {
  const disconnectionFee = get(numbers, ['disconnectionFees', serviceId], {})
  const numberLoading = get(numbers, ['numberLoading', serviceId], false)
  const service = get(numbers, ['numbersById', serviceId], {})
  const formData = get(form, [formName, 'values'], {})

  return {
    fee: disconnectionFee.fee,
    loading: disconnectionFee.loading || numberLoading,
    submitting: disconnectionFee.submitting,
    service,
    reason: formData.reason,
    customReason: formData.customReason,
    initialValues: {
      reason: '',
      customReason: '',
    },
  }
}

const dispatchToProps = {
  getNumber,
  getDisconnectionFee,
  disconnectService,
}

export default connect(
  stateToProps,
  dispatchToProps
)(reduxForm({ form: formName })(NumbersDisconnectModal))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersDisconnectModal/NumbersDisconnectModal.container.js